import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FcmService {
  // messaging = firebase.messaging();
  // currentMessage = new BehaviorSubject(null);

  constructor(/*private db: AngularFireDatabase, private afAuth: AngularFireAuth*/) { }

  updateToken(token) {
    // this.afAuth.authState.pipe(take(1)).subscribe(user => {
    //   if(!user) return;

    //   const data = {
    //     [user.uid]: token
    //   };

    //   this.db.object('fcmTokens/').update(data);
    // });

    //this.db.object('fcmTokens/').update({ ['user_id']: token });
  }

  getPermission() {
    // this.messaging.requestPermission().then(() => {
    //   console.log('Notification permission granted.');

    //   return this.messaging.getToken();
    // }).then(token => {
    //   console.log(token);

    //   this.updateToken(token);
    // }).catch((err) => {
    //   console.log('Unable to get permission to notify.', err);
    // });
  }

  receiveMessage() {
    // this.messaging.onMessage((payload) => {
    //   console.log("Message received. ", payload);

    //   this.currentMessage.next(payload);
    // });
  }
}
